import { decode } from 'blurhash'

export default function getBlurhash(
  blurhash: string,
  width: number = 32,
  height: number = 32
): string {
  const pixels = decode(blurhash, width, height)
  const canvas = document.createElement('canvas')
  canvas.width = width
  canvas.height = height
  const ctx = canvas.getContext('2d')

  if (!ctx) {
    throw new Error('Failed to get 2D context')
  }

  const imageData = ctx.createImageData(width, height)
  imageData.data.set(pixels)
  ctx.putImageData(imageData, 0, 0)
  return canvas.toDataURL()
}
